import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ActionStatusModal from '../../ActionStatusModal';
import H3 from '../../H3';
import { TP } from '../../../constants/consts';
import TextButton from '../../TextButton';
import Button from '../../Button';
import { colors } from '../../../constants/styleConstants';

const ConfirmDeleteModal = ({ closeModal, onDelete, title, text, actionButtonLabel }) => {
  const { t } = useTranslation();
  return (
    <ActionStatusModal
      isOpened
      onClose={closeModal}
      type="warning"
      title={<H3>{title}</H3>}
      buttons={[
        <TextButton
          onClick={closeModal}
          style={{ color: colors.text, fontWeight: 'bold', padding: '0.73rem' }}
          key="approve-button"
        >
          {t(`${TP}.m_CANCEL`)}
        </TextButton>,
        <Button onClick={onDelete} key="cancel-button">
          {t(actionButtonLabel)}
        </Button>,
      ]}
    >
      {text}
    </ActionStatusModal>
  );
};

ConfirmDeleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  actionButtonLabel: PropTypes.string,
};

ConfirmDeleteModal.defaultProps = {
  title: '',
  text: '',
  actionButtonLabel: `${TP}.m_DELETE`,
};

export default ConfirmDeleteModal;
